import { render, staticRenderFns } from "./ColumnFileName.vue?vue&type=template&id=d0bd5e60&"
import script from "./ColumnFileName.vue?vue&type=script&lang=js&"
export * from "./ColumnFileName.vue?vue&type=script&lang=js&"
import style0 from "./ColumnFileName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports